module.exports = __webpack_public_path__ + "static/media/day_three.d98c4d7c.jpg";